import { constructPathURL } from "../utils/constructPathURL.js";
import { SOURCE_CHAT } from "../../constants.js";

export async function operationHour() {
    const operationHourUrl = constructPathURL("/marina/checkoph");

    const operationHourRequest = {
        "channel": SOURCE_CHAT
    };

    return fetch(operationHourUrl, {
        method: "POST", headers: {
            "Content-Type": "application/json"
        }, body: JSON.stringify(operationHourRequest)

    }).then(response => {
        if (!response.ok) {
            throw new Error("Operation hour response was not ok");
        }
        return response.json();

    }).then(result => {
        if (result.code !== "0000") {
            throw new Error("Operation hour response was not success", result.message);
        } else {
            return result;
        }

    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });

}

export async function handoverLiveAgent(chatId, userId, token) {
    const liveAgentUrl = constructPathURL("/marina/api/liveagent");
    const payload = JSON.stringify({
        chat_id: chatId,
        user_id: userId
    });

    return fetch(liveAgentUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: payload

    }).then(response => {
        if (!response.ok) {
            throw new Error("Handover live agent response was not ok");
        }
        return response.json();

    }).then(result => {
        return result;
    }).catch(error => {
        console.error("Fetch error:", error);
        throw error;
    });
}
